import {isProd} from "@src/utils/is-prod"

export const STRIPE_PK = isProd ? 'pk_live_51Moaa3DZwvEBfmAUNSz4ZMp1QU29JDOUnScP3bfYxWM5KruT8bqWSUAhLysV6Q9pxY6QIFEFXVwEdurX9YLHJTjg00AsUz7s8F' : 'pk_test_51Moaa3DZwvEBfmAUsqj7QZigcYe7qTPP6USqTqUPWiVPb7nNJscFXa9AjJewx6QRCmrowUDFYGGGkt519doH47c300S9eiznhK'
